/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_shipmentQuote = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_shipmentQuote" | "PdpRespShippingReturns_shipmentQuote" | "PdpSharedShippingDetails_shipmentQuote">;
    readonly " $refType": "PdpRespContainer_shipmentQuote";
};
export type PdpRespContainer_shipmentQuote$data = PdpRespContainer_shipmentQuote;
export type PdpRespContainer_shipmentQuote$key = {
    readonly " $data"?: PdpRespContainer_shipmentQuote$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_shipmentQuote">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_shipmentQuote",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_shipmentQuote",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingDetails_shipmentQuote",
      "args": null
    }
  ]
};
(node as any).hash = 'f8315b12e30ca5bd8cf2fe9b7e2f51b5';
export default node;
